import { useContext, useEffect, useState } from 'react';
import { StyleContext } from '../../../context/StyleContext';
import { FaStar, FaRegStar } from "react-icons/fa";
import {
    Chart as ChartJS,
    ScatterController,
    LinearScale,
    PointElement,
    Tooltip,
    Legend,
} from 'chart.js';
import { Scatter } from 'react-chartjs-2';
import { Skeleton } from '@mui/material'
import { DashboardContext } from '../../../context/DashboardContext';

ChartJS.register(ScatterController, LinearScale, PointElement, Tooltip, Legend);

export default function Swot({ corFavorito, tab, swotKey }) {
    const { GraficoSwotCiclo, AdicionarGraficoFavorito, getSwot } = useContext(DashboardContext)
    const { theme, chartRef } = useContext(StyleContext)
    const [isLoading, setIsLoading] = useState(false)

    const quadrants = {
        id: 'quadrantsSwot',
        beforeDraw(chart, args, options) {
            const { ctx, chartArea: { left, top, right, bottom }, scales: { x, y } } = chart;

            const midX = x.getPixelForValue((x.min + x.max) / 2);
            const midY = y.getPixelForValue((y.min + y.max) / 2);

            ctx.save();

            ctx.fillStyle = options.topLeft;
            ctx.fillRect(left, top, midX - left, midY - top);
            ctx.fillStyle = options.topRight;
            ctx.fillRect(midX, top, right - midX, midY - top);
            ctx.fillStyle = options.bottomRight;
            ctx.fillRect(midX, midY, right - midX, bottom - midY);
            ctx.fillStyle = options.bottomLeft;
            ctx.fillRect(left, midY, midX - left, bottom - midY);

            ctx.fillStyle = options.textColor || '#000000';
            ctx.font = '12px sans-serif';

            ctx.fillText("Força", left + 10, top + 20);
            ctx.fillText("Oportunidade", midX + 10, top + 20);
            ctx.fillText("Fraqueza", midX + 10, midY + 20);
            ctx.fillText("Ameaça", left + 10, midY + 20);

            ctx.restore();
        },
    };

    const gerarDatasets = (categoria, tipo) => {
        return (categoria ?? []).map((item) => {
            let x = item.x;
            let y = item.y;

            switch (tipo) {
                case 'forca':
                    x = Math.max(1, Math.min(2.9, item.x));
                    y = Math.max(5.9, Math.min(9.9, item.y));
                    break;
                case 'oportunidade':
                    x = Math.max(3.1, Math.min(5, item.x));
                    y = Math.max(5.9, Math.min(10, item.y));
                    break;
                case 'fraqueza':
                    x = Math.max(3.1, Math.min(5, item.x));
                    y = Math.max(1.1, Math.min(5, item.y));
                    break;
                case 'ameaca':
                    x = Math.max(1, Math.min(2.9, item.x));
                    y = Math.max(1.1, Math.min(5, item.y));
                    break;
            }

            return {
                label: item.text,
                data: [{ x, y, originalX: item.x, originalY: item.y, text: item.text }],
                backgroundColor: item.cor,
                borderWidth: 2,
                pointRadius: 8,
            };
        });
    };

    const datasets = [
        ...gerarDatasets(GraficoSwotCiclo?.forca, 'forca'),
        ...gerarDatasets(GraficoSwotCiclo?.fraqueza, 'fraqueza'),
        ...gerarDatasets(GraficoSwotCiclo?.oportunidade, 'oportunidade'),
        ...gerarDatasets(GraficoSwotCiclo?.ameaca, 'ameaca'),
    ];

    const data = {
        datasets,
    };

    const options = {
        plugins: {
            quadrantsSwot: {
                topLeft: "rgba(138, 181, 78, 0.1)",
                topRight: "rgba(254, 242, 242, 0.2)",
                bottomLeft: "rgba(219, 244, 255, 0.2)",
                bottomRight: "rgba(254, 252, 232, 0.2)",
                textColor: theme == 'dark' ? '#52525b' : '#ffffff'
            },
            legend: {
                display: false
            },
            tooltip: {
                callbacks: {
                    title: (tooltipItems) => {
                        return tooltipItems.map(item => item.raw.text).join(', ');
                    },
                    label: (tooltipItem) => {
                        const { originalX, originalY } = tooltipItem.raw;
                        return `x: ${originalX}, y: ${originalY}`;
                    }
                }
            },
        },
        scales: {
            x: {
                display: false,
                min: 0.9,
                max: 5.1,
            },
            y: {
                display: false,
                min: 0.7,
                max: 10.3,
            },
        },
    };

    useEffect(() => {
        if (swotKey != "") {
            const parsedKey = JSON.parse(swotKey)
            setIsLoading(true)
            getSwot(parsedKey.key)
                .then(() => {
                    setIsLoading(false)
                })
        }
    }, [swotKey])

    return (
        <>
            <div>
                <div>
                    <h2 className="h2-bsc" style={{ width: '100%', borderRadius: '0px' }}>
                        <button onClick={() => AdicionarGraficoFavorito("SWOT")} className='btn-grafico'>{corFavorito("SWOT") ? <FaRegStar /> : <FaStar style={{ color: 'orange' }} />}</button>
                        <span style={{ fontWeight: '500' }}>SWOT</span>
                    </h2>
                    {GraficoSwotCiclo &&
                        <>
                            <div style={{ display: 'flex', gap: '50px', padding: '10px 10px 10px 0' }}>
                                {isLoading ?
                                    <Skeleton variant="rounded" width="100%" height={600} />
                                    :
                                    <div style={{ width: '70%', margin: 'auto' }}>
                                        <Scatter ref={chartRef} data={data} options={options} plugins={[quadrants]} />
                                    </div>
                                }
                            </div>
                        </>
                    }
                </div>
            </div>
        </>
    )
}